export default class TypeWriter {
  constructor(element, options = {}) {
    this.element = element;
    this.text = options.text || "";
    this.delay = options.delay || 60;
    this.onComplete = options.onComplete || null;

    this.currentIndex = 0;
    this.isTyping = false;
  }

  start() {
    if (this.isTyping || !this.text) return;

    this.isTyping = true;
    this.currentIndex = 0;
    this.element.textContent = "";
    this.typeNext();
  }

  typeNext() {
    if (this.currentIndex < this.text.length) {
      this.element.textContent += this.text[this.currentIndex];
      this.currentIndex++;
      setTimeout(() => this.typeNext(), this.delay);
    } else {
      this.isTyping = false;
      if (this.onComplete) {
        this.onComplete();
      }
    }
  }

  setText(text) {
    this.text = text;
  }
}
